(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('CommentDetailController', CommentDetailController);

    CommentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Comment', 'CustomUser', 'SpecificQuestion', 'Answer', 'FrequentlyAskedQuestion', 'Handbook'];

    function CommentDetailController($scope, $rootScope, $stateParams, previousState, entity, Comment, CustomUser, SpecificQuestion, Answer, FrequentlyAskedQuestion, Handbook) {
        var vm = this;

        vm.comment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:commentUpdate', function(event, result) {
            vm.comment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
